import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Container, Button, Dropdown } from 'react-bootstrap';
import ReactTooltip from "react-tooltip";
import { FlexboxGrid, List } from "rsuite";
import { RootState } from "../services/rootReducer";
import { cursorsType, setCursors, setPageRangeUsed, selectCursors, selectViewType, selectPageRange, selectDateInterval, selectCalendarRange } from 'services/View_Slice';
import MinusIcon from "@material-ui/icons/ArrowBackIos";
import PlusIcon from "@material-ui/icons/ArrowForwardIos";
import CONSTANTS from "../constants";
import styles from "./css/ResultsListView.module.css";
//import useWindowDimensions from "./utils/useWindowDimensions";
import ResultListItem  from "./ResultListItem";
import logger from 'logger';
import DateNav from "components/DateNav";
import ViewSwitch from "components/ViewSwitch";
import SortControl from "components/SortControl";
import LatestEntryInfo from "components/LatestEntryInfo";
import DateIntervalPicker from "components/DateIntervalPicker";
import FlexboxGridItem from 'rsuite/lib/FlexboxGrid/FlexboxGridItem';
//import {Grid, Col} from 'rsuite';
import { format, parseISO } from 'date-fns';
// import { setLoading } from 'services/Loading_Slice';
/****************************************************
* DOWNLOAD FEATURE - TEMPORARILY DISABLED
****************************************************/
// import { clearUrls, addUrl } from 'services/Download_Slice';
import InlineSpinner from './InlineSpinner';

type screenValues = {
  mobile: boolean,
  width: number
}

function ResultsListView(props: React.PropsWithChildren<screenValues>) {
    const dispatch = useDispatch();
    const loading = useSelector((state: RootState) => state.Loading.loading)
    const viewType = useSelector(selectViewType);
    const { cursorStart } = useSelector(selectCursors);
    const pageRangeUsed = useSelector(selectPageRange);
    const { dateIntervalFrom, dateIntervalTo } = useSelector(selectDateInterval);
    const { calRangeUsed, calRangeValue } = useSelector(selectCalendarRange);
    const mobile = useSelector((state: RootState) => state.View.mobile);
    const result = useSelector((state: RootState) => state.Query.result);

    const facetSelected = useSelector((state: RootState) => state.Facets.facetSelected);
    const freeTextSearch = useSelector((state: RootState) => state.Search.freeTextSearch);
    const latestDateInfo = useSelector((state: RootState) => state.FacetNavigation.latestDateInfo);

    /****************************************************
    * DOWNLOAD FEATURE - TEMPORARILY DISABLED
    ****************************************************/
    // const {urls} = useSelector((state: RootState) => state.Download);

    /****************************************************
    * DOWNLOAD FEATURE - TEMPORARILY DISABLED
    ****************************************************/
    // used for pdf zip download
    // const [downloading, setDownloading] = useState(false)
    /****************************************************
    * DOWNLOAD FEATURE - TEMPORARILY DISABLED
    ****************************************************/
    // used for the select all button
    // const [selected, setSelected] = useState(false)
    // used for select all button check state
    // const [checked, setChecked] = useState(false)

    /****************************************************
    * DOWNLOAD FEATURE - TEMPORARILY DISABLED
    ****************************************************/
    // if loading value in the store changes => then clear selected and urls (in store)
    // useEffect(() => {
    //   setSelected(false);
    //   setChecked(false)
    //   dispatch(clearUrls());
    // }, [loading, downloading])

    //
    //const usedPageRangeLabel = mobile ? styles.glPageRangeLabel_mobile : styles.glPageRangeLabel
    //const usedContainer = mobile ? styles.container : styles.container
    const usedLabelStyle = mobile ? styles.label_mobile: styles.label;
    const usedGlPageRangeLabel = mobile ? styles.glPageRangeLabel_mobile: styles.glPageRangeLabel;
    const usedGlIconStyle = mobile ? styles.glIcon_mobile: styles.glIcon;

    //const usedGlButton = mobile ? styles.glButton_mobile: styles.glButton;
    // for pagination
    const usedGlButton = mobile ? styles.glPageButton_mobile: styles.glPageButton; 
    const usedGlPageButton = mobile ? styles.glPageButton_mobile: styles.glPageButton;
    const usedGlPageLabelStyle = mobile ? styles.glPageLabel_mobile: styles.glPageLabel;
    //
    const usedPaginationChoiceStyle = mobile ? styles.paginationChoice_mobile: styles.paginationChoice;
    const usedGlDropdown = mobile ? styles.glDropdown_mobile: styles.glDropdown;
    const usedTitleLabel = mobile ? styles.title_mobile: styles.title;
    const usedSearchStatusTitle = mobile ? styles.searchStatusTitle_mobile : styles.searchStatusTitle;

    //const flexboxtype = mobile ? "center" : "end"

    // Helper function to check if search is active
    const isSearchActive = !!(freeTextSearch && freeTextSearch.trim().length > 0);

    // Check if LatestEntryInfo would be visible (filters applied, not in search mode)
    // Used to apply 2-row centered layout for control bar when filter info is displayed
    const hasFiltersApplied = !isSearchActive && latestDateInfo !== null;

    // Helper function to build date range text for no results message
    const getDateRangeText = () => {
      if (!dateIntervalFrom && !dateIntervalTo) return '';
      const fromText = dateIntervalFrom ? format(parseISO(dateIntervalFrom), 'd MMM yyyy') : '';
      const toText = dateIntervalTo ? format(parseISO(dateIntervalTo), 'd MMM yyyy') : '';
      if (fromText && toText) return ` for ${fromText} - ${toText}`;
      if (fromText) return ` from ${fromText}`;
      if (toText) return ` until ${toText}`;
      return '';
    };

    // Helper function to build no results message
    const getNoResultsMessage = () => {
      const dateRange = getDateRangeText();
      if (freeTextSearch && dateRange) {
        return `No reports found matching "${freeTextSearch}"${dateRange}`;
      } else if (freeTextSearch) {
        return `No reports found matching "${freeTextSearch}"`;
      } else if (dateRange) {
        return `No reports found${dateRange}`;
      }
      return "No reports available for the selected filters";
    };

    // Helper function to build search status title
    const buildSearchStatusTitle = () => {
      const parts: React.ReactNode[] = [];

      // 1. Search term
      parts.push(
        <span key="search-term">
          Showing results for "<span className={styles.searchKeyword}>{freeTextSearch}</span>"
        </span>
      );

      // 2. Facet filters
      if (facetSelected.length > 0) {
        const filterParts = facetSelected.map(f => {
          const [value, field] = f.split('@');
          const displayName = CONSTANTS.UI.FACETS_ALIAS[field] || field;
          return `${displayName}: ${value}`;
        });
        parts.push(
          <span key="filters" className={styles.searchFilters}>
            {' | '}Filters: {filterParts.join(', ')}
          </span>
        );
      }

      // 3. Date interval
      if (dateIntervalFrom && dateIntervalTo) {
        parts.push(
          <span key="date-interval" className={styles.searchFilters}>
            {' | '}Date: {dateIntervalFrom} to {dateIntervalTo}
          </span>
        );
      } else if (dateIntervalFrom) {
        parts.push(
          <span key="date-interval" className={styles.searchFilters}>
            {' | '}Date: from {dateIntervalFrom}
          </span>
        );
      } else if (dateIntervalTo) {
        parts.push(
          <span key="date-interval" className={styles.searchFilters}>
            {' | '}Date: until {dateIntervalTo}
          </span>
        );
      }

      // 4. No filters message
      if (facetSelected.length === 0 && !dateIntervalFrom && !dateIntervalTo) {
        parts.push(
          <span key="no-filters" className={styles.searchNoFilters}>
            {' | '}no additional filters applied
          </span>
        );
      }

      return parts;
    };

    var numFound: number = 0;
    var resStart: number = 0;
    var docs:any = []; 
    var numDocs = 0;
    if(result!==undefined && result["numFound"] !== undefined){
      numFound = result["numFound"];
      docs = result["docs"];
      numDocs = docs.length;
      resStart = result["start"]!==undefined ? result["start"] : -1;
    }

    // check nav button + pages
    const pageIndex: number = Math.floor(resStart/pageRangeUsed); // starts at 0
    const pageTop: number = Math.ceil(numFound/pageRangeUsed);
    const navMinus = resStart>0 ? true: false;
    const navPlus = (resStart + numDocs) <  numFound ? true: false;
    //logger.debug("## resultListView2: (resStart + numDocs):" + (resStart + numDocs));
    //logger.debug("## resultListView2: numDocs:" +numDocs+ "; numFound:" + numFound);
    //logger.debug("## resultListView2: pageIndex:" +pageIndex+ "; pageTop:" + pageTop);


    // pagination button settings
    const maxButton = 13;
    var lessZone = false;
    var moreZone = false;
    var lessZoneIndex = 0;
    var lessZoneStart = 0;
    var lessZoneStop = 0;
    var moreZoneStart = 0;
    var moreZoneStop = 0;
    var moreZoneIndex = 0;
    if (pageTop>maxButton){
      // xZone 
      if(pageIndex >= maxButton/2-1){
        lessZone = true;
        lessZoneStart = 2;
        lessZoneStop = pageIndex - (maxButton/3)+3;
        lessZoneIndex = 2
      }
      if(pageIndex < (pageTop - maxButton/2)){
        moreZone = true;
        moreZoneStart = pageIndex + (maxButton/3)-3;
        moreZoneStop = pageTop - 3;
        moreZoneIndex = pageTop - 3;
      }
    }
    

    //var n=0;
    let range = Array.from(Array(pageTop).keys());
    //logger.debug("## resultListView2: range:" + range);
    //logger.debug("## resultListView2: lessZone:" + JSON.stringify(lessZone)+"; moreZone:" + JSON.stringify(moreZone));
    //logger.debug("## resultListView2: lessZoneStart:" + lessZoneStart+"; lessZoneStop:" + lessZoneStop+"; lessZoneIndex:" + lessZoneIndex);
    //logger.debug("## resultListView2: moreZoneStart:" + moreZoneStart+"; moreZoneStop:" + moreZoneStop+"; moreZoneIndex:" + moreZoneIndex);


    // the pagination buttons
    const PageButtonToRender = range.map(value => {

      

      var show: boolean = true;
      var zone: boolean = false;

      if(moreZone === true && (value>moreZoneStart && value<moreZoneStop)){
        show = false;
      }

      if(lessZone === true && (value>lessZoneStart && value<lessZoneStop)){
        show = false;
      }

      if((lessZone === true && value === lessZoneIndex) || (moreZone === true && value === moreZoneIndex)){
        zone = true;
      }


      if( zone === true ){
          return(
            <span key={'dot_' + value} className={usedLabelStyle}> . . . </span>
          )
      }else if(show === false){
        return(
          null
        )
      }else{

        const outLineType = value!==(pageIndex) ? "outline-light" : "light";
        const toolTipId = String(value+1);
        // start at index 0
        const newStart = pageRangeUsed * value;
        const newRows = newStart + pageRangeUsed - 1 < numFound ? pageRangeUsed : numFound - newStart + 1;

        return(
              <span key={value}>
                <Button variant={outLineType}
                    onClick = {(e) => {


                        // Update cursor position - Query.tsx will dispatch query
                        const cursorInfo: cursorsType = {cursorStart: newStart, cursorRows: newRows};
                        dispatch(setCursors(cursorInfo));
                    }}
                    value={value}
                    className={usedGlButton}
                    data-for={toolTipId}
                    data-tip
                    >
                  <div className={usedGlPageLabelStyle}>{value+1}</div>

                </Button>
                <ReactTooltip className={styles.glToolTip} id={toolTipId} place="bottom" effect="solid" textColor='#000000'backgroundColor={CONSTANTS.UI.TOOLTIP_COLOR}>
                  Page {toolTipId} : from {newStart} to {newStart+newRows-1}
                </ReactTooltip>
              </span>

        );

      }

    });
    //logger.debug("## resultListView2: PageButtonToRender length:" + PageButtonToRender.length);

    // the list items
    range = Array.from(Array(numDocs).keys());

    // the items per page dropdown
    const dropDownPaginationItemsToRender = Object.keys(CONSTANTS.UI.ITEM_PER_PAGE_CHOICES).map(ind => {
      return(
          <Dropdown.Item key={CONSTANTS.UI.ITEM_PER_PAGE_CHOICES[ind]} eventKey={CONSTANTS.UI.ITEM_PER_PAGE_CHOICES[ind]} className={usedPaginationChoiceStyle}>{CONSTANTS.UI.ITEM_PER_PAGE_CHOICES[ind]}</Dropdown.Item>
      )
    });

    // calculate end of the week
    const calcLastWeekDay = (value : number, month: string) =>{
      var date = parseISO(calRangeValue)
      var endDate = new Date(date.setDate(date.getDate() + 6))
      var anEndDateStr = format(endDate, "yyyy-MM-dd")
      return anEndDateStr;
    }

    /****************************************************
    * DOWNLOAD FEATURE - TEMPORARILY DISABLED
    ****************************************************/
    // TODO
    // handle download request to backend and return .zip file with pdfs
    // const handleDownload = async () => {
    //   // loading state activated
    //   setDownloading(true)
    //   
    //   console.log("HANDLE DOWNLOAD STARTED...");
    //   
    //   // create the body of the POST req
    //   var body = ''
    //   for(var elem of urls){
    //     body = body + 'uri=' + elem + '&';
    //   }
    //   console.log("STRINGS: ", body);
    //   // clear the store of urls
    //   dispatch(clearUrls()); 

    //   const requestOptions = {
    //     method: 'POST',
    //     headers: { 
    //       'Content-Type': 'text/plain'
    //     },
    //     body: body
    //   };

    //   // execute POST req and read response
    //   try{
    //     var url_string: string = CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_QRARCHIVE_POST;

    //     setSelected(false);

    //     // create timeout and abort controller
    //     const timeout = CONSTANTS.DOWNLOAD_TIMEOUT;
    //     const controller = new AbortController();
    //     const id = setTimeout(() => controller.abort(), timeout);

    //     // get the response and clear timeout
    //     const response = await fetch(url_string, {...requestOptions, signal: controller.signal});
    //     clearTimeout(id);

    //     const blob = await response.blob();
    //     const url = window.URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.setAttribute('download', 'qr_zip_archive');
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //   }catch(error){
    //     console.log('ERROR: [' + error + ']');
    //   }

    //   // con questo fai il refresh di tutta la pagina per risolvere i checked delle checkbox (ma non va bene)
    //   //window.location.reload();
    // }

    // const downloader = () => {
    //   handleDownload().then(() => setDownloading(false))
    // }

  /****************************************************
  * DOWNLOAD FEATURE - TEMPORARILY DISABLED
  ****************************************************/
  // select all checkboxes feature
  // const selectAll = (event: { target: { checked: any; }; }) => {
  //   if(event.target.checked) {
  //     console.log("checked"); 
  //     setChecked(true)
  //     setSelected(true)
  //     // add all urls to the store
  //     for(var i in range){
  //       dispatch(addUrl(docs[i][CONSTANTS.RESULT.FIELD_URL]));
  //     }
  //   }else{
  //     console.log("not checked");
  //     setChecked(false)
  //     setSelected(false)
  //     // clear urls from the store
  //     dispatch(clearUrls());
  //   }
  // };


    // end of the week
    var endDateStr = calcLastWeekDay(parseInt(calRangeValue.split("-")[2]), calRangeValue.split("-")[1])

    const dimStyle: React.CSSProperties = { opacity: 0.5, pointerEvents: 'none' };

    /****************************************************
    * DOWNLOAD FEATURE - TEMPORARILY DISABLED
    ****************************************************/
    // else if(downloading){
    //   elem = <OverlayComp/>;
    // }

    return (
      <div style={{ position: 'relative' }}>
        {loading && <InlineSpinner />}
        <Container className={styles.container} style={loading ? dimStyle : undefined}>

          {isSearchActive && (
            <div className={mobile ? styles.searchHelperText_mobile : styles.searchHelperText}>
              To return to calendar view, clear your search by clicking the ✕ button
            </div>
          )}

          <FlexboxGrid className={styles.controlBar} style={{paddingTop: '15px'}} justify="space-between">

            <FlexboxGridItem>
              <FlexboxGrid
                className={`${styles.paddingLeft} ${styles.controlBarLeft}${hasFiltersApplied ? ` ${styles.filtersApplied}` : ''}`}
                justify={hasFiltersApplied ? "center" : "space-around"}
              >

                {!isSearchActive && (
                  <FlexboxGridItem>
                    <LatestEntryInfo />
                  </FlexboxGridItem>
                )}

                <FlexboxGridItem>
                  { viewType===0 ?
                  <SortControl/>
                  : <span></span>
                  }
                </FlexboxGridItem>

                <FlexboxGridItem>
                  { numFound > 0 ?
                  <div className={styles.divPageRange}>
                  <div className={usedGlPageRangeLabel}>Show</div>
                  <Dropdown
                    className={usedGlDropdown}
                    onSelect={(e) => {
                        //logger.info("@@@@@@@@@ dropdown paginationRange:" + e);
                        const newPageRangeUsed: number = Number(e);

                        if(newPageRangeUsed !== pageRangeUsed){

                          const newPage = Math.floor(cursorStart/newPageRangeUsed);
                          const newStart = newPage*newPageRangeUsed;
                          const newRows = newStart + newPageRangeUsed <numFound ? newPageRangeUsed : newPageRangeUsed - (numFound - (newStart + newPageRangeUsed));
                          //logger.info("@@@@@@@@@ dropdown paginationRange: newPage=" + newPage + "; newStart=" + newStart + "; newRows=" + newRows);

                          // Update state - Query.tsx will dispatch query
                          const cursorInfo: cursorsType = {cursorStart: newStart, cursorRows: newRows};
                          dispatch(setCursors(cursorInfo));
                          dispatch(setPageRangeUsed(newPageRangeUsed));
                        }
                    }}
                  >
                  <Dropdown.Toggle variant="outline" id="dropdown-paginationRange"
                    size="sm"
                    data-for="tipPaginationRange"
                    data-tip>
                    <span className={usedLabelStyle}>{pageRangeUsed}</span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <span className={usedLabelStyle}>{dropDownPaginationItemsToRender}</span>
                  </Dropdown.Menu>
                  </Dropdown>
                  <ReactTooltip className={styles.glToolTip} id="tipPaginationRange" place="top" effect="solid" textColor='#000000'backgroundColor={CONSTANTS.UI.TOOLTIP_COLOR}>
                    Change pagination range
                  </ReactTooltip>
                    </div>
                    :<div></div>}
                </FlexboxGridItem>

                <FlexboxGridItem>
                  { viewType===0 && isSearchActive ?
                  <DateIntervalPicker/>
                  : <span></span>
                  }
                </FlexboxGridItem>
              
              </FlexboxGrid>
            </FlexboxGridItem>

            {!isSearchActive && (
            <FlexboxGridItem>
              <FlexboxGrid className={`${styles.paddingRight} ${styles.controlBarRight}`} justify="space-around">

                <FlexboxGridItem>
                  <ViewSwitch/>
                </FlexboxGridItem>

                <FlexboxGridItem>
                  <DateNav mobile={props.mobile} width={props.width}/>
                </FlexboxGridItem>


              </FlexboxGrid>
            </FlexboxGridItem>
            )}

          </FlexboxGrid>


          <FlexboxGrid justify="center">
              {/* When search is active, show search status instead of date title */}
              {isSearchActive ? (
                <div className={usedSearchStatusTitle}>
                  {buildSearchStatusTitle()}
                </div>
              ) : (
                <>
                  {calRangeUsed === 0 ?
                    <div className={usedTitleLabel}>{CONSTANTS.MONTHS.FULL[parseInt(calRangeValue.split("-")[1])]} {calRangeValue.split("-")[0]}</div>
                    : <span></span>
                  }
                  {calRangeUsed === 1 ?
                    calRangeValue.split('-')[0] !== endDateStr.split('-')[0] ?
                    <div className={usedTitleLabel}>
                      Week from {calRangeValue.split("-")[2]} {CONSTANTS.MONTHS[parseInt(calRangeValue.split("-")[1])]}
                      &nbsp;to {endDateStr.split('-')[2]} {CONSTANTS.MONTHS[parseInt(endDateStr.split('-')[1])]}
                      &nbsp;- {calRangeValue.split("-")[0]}/{endDateStr.split('-')[0]}
                      </div>
                      :
                      <div className={usedTitleLabel}>
                      Week from {calRangeValue.split("-")[2]} {CONSTANTS.MONTHS[parseInt(calRangeValue.split("-")[1])]}
                      &nbsp;to {endDateStr.split('-')[2]} {CONSTANTS.MONTHS[parseInt(endDateStr.split('-')[1])]}
                      &nbsp;- {calRangeValue.split("-")[0]}
                      </div>
                      : <span></span>
                  }
                  {calRangeUsed === 3 ?
                    <div className={usedTitleLabel}>{calRangeValue}</div>
                    : <span></span>
                  }
                </>
              )}
          </FlexboxGrid>

          {/****************************************************
          * DOWNLOAD FEATURE - TEMPORARILY DISABLED
          ****************************************************/}
          {/* download button and features */}
          {/*<FlexboxGrid justify='start'>
            <FlexboxGridItem style={{flex: 1}}>
              <FlexboxGrid className={styles.download_container} justify='start' align='middle'>
                <FlexboxGridItem className={styles.paddingRight20}>
                  <>
                    <input type="checkbox" checked={checked} onChange={selectAll}></input>
                    <label className={styles.paddingLeft5}>Select All</label>
                  </>
                </FlexboxGridItem>
                <FlexboxGridItem className={styles.paddingRight20}>
                  <label> {urls.length} Selected </label>
                </FlexboxGridItem>
                <FlexboxGridItem className={styles.paddingRight20}>
                  {urls.length > 0 ? 
                      <>
                        <Button className={styles.download_button} onClick={downloader}>
                          <img className={styles.download_icon} src='./images/download.png' alt='download' />
                          Download
                        </Button>
                      </>
                      :
                      <Button className={styles.download_button} onClick={downloader} disabled={true}>
                        <img className={styles.download_icon} src='./images/download.png' alt='download' />
                        Download
                      </Button>  
                  }
                </FlexboxGridItem>
              </FlexboxGrid>
            </FlexboxGridItem>
            <FlexboxGridItem style={{flex: 1}}>
              <>
              </>
            </FlexboxGridItem>
          </FlexboxGrid>*/}

          {numFound > 0 ?
          <div className={styles.listItems}>
            <List hover>
              {
                range.map(value => {
                  return(
                    <ResultListItem checked={false} key={value} id={value} index={resStart+value} doc={docs[value]} width={props.width} mobile={props.mobile}/>
                  )
                  {/****************************************************
                  * DOWNLOAD FEATURE - TEMPORARILY DISABLED
                  * Original line: <ResultListItem checked={selected} key={value} id={value} index={resStart+value} doc={docs[value]} width={props.width} mobile={props.mobile}/>
                  ****************************************************/}
                })
              }
            </List>
          </div> :
          <div style={{textAlign: "center", fontStyle: 'italic'}}>
            <br></br>
            <h4>{getNoResultsMessage()}</h4>
          </div>
          }

          <FlexboxGrid className={styles.paddingLeft} justify="space-between" align="middle">
            <FlexboxGridItem>
              {numFound > 0 ?
              <div className={usedLabelStyle}>
                Showing {resStart + 1} to {resStart + numDocs} of {numFound} files
              </div> : 
              <span></span>
              }
              {/* <div className={usedLabelStyle}>
              Total found:{numFound}
              </div>
              <div className={usedLabelStyle}>Show {numDocs} items starting at index:{resStart}</div>
              <div className={usedLabelStyle}> Range used: {pageRangeUsed}</div> */}
            </FlexboxGridItem>

            <FlexboxGridItem className={styles.paddingRight}>
              <div className={styles.divPagination}>
              {navMinus === true ? 
              <span>
              <Button variant="outline-secondary" className={usedGlPageButton}
                onClick={() => {
                    // set cursor. Add cursor info to query, run query
                    const newStart = resStart - pageRangeUsed >0 ? resStart - pageRangeUsed : 0;
                    const newRows = resStart - pageRangeUsed >0 ? pageRangeUsed : pageRangeUsed - (resStart - pageRangeUsed);

                    // Update cursor - Query.tsx will dispatch query
                    const cursorInfo: cursorsType = {cursorStart: newStart, cursorRows: newRows};
                    dispatch(setCursors(cursorInfo));
                  }}
                  data-for="minus"
                  data-tip
              >
              <MinusIcon className={usedGlIconStyle}/>
              </Button>
              <ReactTooltip className={styles.glToolTip} id="minus" place="bottom" effect="solid" textColor='#000000'backgroundColor={CONSTANTS.UI.TOOLTIP_COLOR}>
              Previous
              </ReactTooltip>
              </span>
              :<span></span>}


              {PageButtonToRender}


              {navPlus === true ? 
              <div>
              <Button variant="outline-secondary" className={usedGlButton}
                  onClick={() => {
                      // set next cursor start + rows
                      const newStart = resStart + pageRangeUsed <numFound ? resStart + pageRangeUsed : numFound;
                      const newRows = newStart + pageRangeUsed <numFound ? pageRangeUsed : pageRangeUsed - (numFound - (newStart + pageRangeUsed));

                      // Update cursor - Query.tsx will dispatch query
                      const cursorInfo: cursorsType = {cursorStart: newStart, cursorRows: newRows};
                      dispatch(setCursors(cursorInfo));
                    }}
                    data-for="plus"
                    data-tip
                >
                <PlusIcon className={usedGlIconStyle}/>
              </Button>
              <ReactTooltip className={styles.glToolTip} id="plus" place="bottom" effect="solid" textColor='#000000'backgroundColor={CONSTANTS.UI.TOOLTIP_COLOR}>
              Next
              </ReactTooltip>
              </div>
              : <div></div>}
              </div>
            </FlexboxGridItem>
          </FlexboxGrid>
        </Container>
      </div>
    );
    
}

export default ResultsListView;